/**
 * webBridge
 * 管理 iframe 和 主页面的通讯
 */

export const useWebBridgeStore = defineStore({
  id: 'webBridge',
  state: () => ({
    /** webViewId */
    webViewId: 'webView',
    /** 常量函数名 */
    funName: {
      GET_UID: 'getUid',
      GET_ROOM_ID: 'getRoomId',
      GET_TICKET: 'getTicket',
      GET_LANGUAGE: 'getLanguage',
      CLOSE_WIN: 'closeWin', // 关闭窗口
      CLOSE_WEB_VIEW: 'closeWebView', // 关闭游戏窗口
      SHOW_LOADING: 'showLoading', // 显示加载中
      CLOSE_LOADING: 'closeLoading', // 关闭加载中
      TO_PAGE: 'toPage', // 跳转页面： 充参： Number: 对应pages的type,
      OPEN_RECHARGE_POPUP: 'openRechargePopup', // 打开充值弹窗
      VERIFY_FACE: 'verifyFace', // 打开人脸认证,
      SET_TITLE: 'setTitle', // 获取活动title
      GET_ROOM_INFO: 'getRoomInfo', // 获取房间信息
      GET_ROOM_TYPE: 'getRoomType' // 获取房间类型
    },
    /** 内嵌H5打开网页端页面页面配置，有在白名单才跳转 */
    webPageRoutes: {
      /** 充值页面 */
      recharge: '/recharge'
    },
    /** 内嵌H5页面链接Key */
    h5PageRoutesKey: {
      chatPrice: 'chatPrice',
      withdraw: 'withdraw',
      withdrawList: 'withdrawList',
      bomb: 'bomb'
    },
    /** 内嵌H5页面链接 */
    h5PageRoutes: {
      /** 聊天价格 */
      chatPrice: {
        title: 'My chat price',
        path: useRuntimeConfig().public.h5Url + '/build/index.html#/chatPrice'
      },
      /** 提现页 */
      withdraw: {
        title: 'Withdraw',
        path: useRuntimeConfig().public.h5Url + '/build2/index.html#/withdraw'
      },
      /** 提现记录 */
      withdrawList: {
        title: 'Withdraw record',
        path:
          useRuntimeConfig().public.h5Url + '/build/index.html#/withDrawList'
      },
      /** 炸弹页面 */
      bomb: {
        title: 'Bomb rule',
        path: useRuntimeConfig().public.h5Url + '/build/index.html#/bomb'
      }
    },
    /** 弹窗webView配置信息 */
    webViewPopupConfig: {
      // webView弹窗配置
      isShowPopup: false as boolean, // webView 开启关闭
      isLazyShow: false,
      key: '' as string, // 打开的链接
      popupClass: '' // 弹窗类名
    }
  }),
  actions: {
    /**
     * 打开 webView
     * @param {1|2} type  1：页面，2弹窗
     * @param {string} key 跳转页面,key值，路径等
     * @param {string} title 标题
     * @param {boolean} isShowPopup 弹窗是否显示
     * @param {string} popupClass 弹窗类名
     * */
    setWebView(config: {
      type: 1 | 2
      key?: string
      isShowPopup?: boolean
      popupClass?: string
      title?: string
    }) {
      const router = useRouter()
      // 如果 key值不存在，添加新的到 h5PageRoutes
      if (config.key && !(config.key in this.h5PageRoutesKey)) {
        // 设置key值
        this.h5PageRoutesKey[config.key] = config.key
        // 设置页面信息
        this.h5PageRoutes[config.key] = {
          title: config.title,
          path: config.key
        }
      }
      switch (config.type) {
        case 1:
          router.push('/webView/' + config.key)
          break
        case 2:
          this.webViewPopupConfig.isShowPopup = config.isShowPopup || false
          this.webViewPopupConfig.isLazyShow = true
          // 这样关闭是为了保留滑动效果
          if (config.key) {
            this.webViewPopupConfig.key = config.key
          }
          if (config.popupClass || config.popupClass === '') {
            this.webViewPopupConfig.popupClass = config.popupClass
          }
          break
      }
    },
    /** 收到iframe监听 */
    onMessage(event) {
      console.log('onMessage', event)

      // 先判断是否是子页面过来的信息
      if (event.data.funName) {
        // 获取 webView DOM
        const webViewDom = document.getElementById(this.webViewId)

        const router = useRouter()
        const route = useRoute()

        const publicStore = usePublicStore()
        const roomStore = useRoomStore()
        const languageStore = useLanguageStore() // 此字段不限制于接口，所以可以直接使用

        // 需要回调的数据
        const callbackData = {
          funName: event.data.funName,
          callbackFunName: event.data.callbackFunName,
          data: {} as { [prop: string]: string | number }
        }
        // 判断函数名，区分，处理请写这里
        switch (event.data.funName) {
          // 获取uid
          case this.funName.GET_UID:
            if (localStorage.getItem('loginInfo')) {
              const loginInfo = JSON.parse(
                localStorage.getItem('loginInfo') as string
              )
              callbackData.data.uid = loginInfo.uid
            }
            break
          // 获取roomid
          case this.funName.GET_ROOM_ID:
            callbackData.data.roomId = roomStore.roomId || 0
            break

          // 获取房间信息
          case this.funName.GET_ROOM_INFO:
            callbackData.data.roomInfo = JSON.stringify({
              roomId: roomStore.roomId || 0,
              roomUid: roomStore.roomUid || 0
            })
            break

          // 获取房间类型
          case this.funName.GET_ROOM_TYPE:
            callbackData.data.roomType = roomStore.roomType
            break

          // 获取ticket
          case this.funName.GET_TICKET:
            if (localStorage.getItem('ticket')) {
              callbackData.data.ticket = localStorage.getItem('ticket') || ''
            }
            break

          // 获取language
          case this.funName.GET_LANGUAGE:
            if (languageStore.languageInfo.value) {
              callbackData.data.language =
                languageStore.languageInfo.value || ''
            }
            break

          // 关闭窗口
          case this.funName.CLOSE_WEB_VIEW:
            this.setWebView({
              type: 2,
              isShowPopup: false,
              popupClass: ''
            })
            break

          // 关闭窗口
          case this.funName.CLOSE_WIN:
            this.setWebView({
              type: 2,
              isShowPopup: false,
              popupClass: ''
            })
            break
          // 显示加载中
          case this.funName.SHOW_LOADING:
            showLoadingToast({
              message: '',
              forbidClick: false,
              duration: 0
            })
            break
          // 关闭加载中
          case this.funName.CLOSE_LOADING:
            closeToast()
            break
          // 跳转界面
          case this.funName.TO_PAGE:
            // 跳转前需要先关闭webView
            this.setWebView({
              type: 2,
              isShowPopup: false,
              popupClass: ''
            })

            // 如果是在直播页面，想关闭退出确认框，直接跳转
            if (route.path === '/room/live') {
              roomStore.setIsShowLiveRouteLeavDialog(false)
            }

            // 有在白名单才跳转
            if (this.webPageRoutes[event.data.data]) {
              router.push({
                path: this.webPageRoutes[event.data.data],
                replace: route.path.indexOf('/room/call') !== -1 // 如果当前是/room/call页面就需要特殊处理，先关闭当前页面
              })
            }
            break
          // 打开充值弹窗
          case this.funName.OPEN_RECHARGE_POPUP:
            publicStore.setShowRechargePopup(true)
            break
          // 人脸认证
          case this.funName.VERIFY_FACE:
            router.push({ path: '/verify' })
            break
          // 获取活动的title
          case this.funName.SET_TITLE:
            event.data.data.title &&
              (this.h5PageRoutes[event.data.data.activeName].title =
                event.data.data.title)
            break
        }

        // 查看是否需要回调
        if (webViewDom && event.data.callbackFunName) {
          event.data.callbackFunName &&
            webViewDom['contentWindow'].postMessage(callbackData, '*')
        }
      }
    },
    /** 开启message监听 */
    startMessage() {
      window.addEventListener('message', this.onMessage)
    },
    /** 移除message监听 */
    removeMessage() {
      window.removeEventListener('message', this.onMessage, false)
    }
  },
  persist: {
    key: 'webBridgeStore',
    paths: ['h5PageRoutesKey', 'h5PageRoutes']
  }
})
